import React, { useCallback } from "react";
import BusinessIcon from "@mui/icons-material/Business";
import FormValidation from "../../../components/FormValidation/FormValidation";
import formFields from "../../../config/formFields.json";

const AddClient = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  industries = [],
  countries = [],
  // cities = [],
  // clientDesignations = [],
  fetchCountryCities,
  countryCities = [],
  onDependencyChange,
}) => {
  const isEdit = !!initialData;
  console.log("isEdit", isEdit, initialData);
  const initialValues = {
    client_name: initialData?.client_name || "",
    client_code: initialData?.client_code || "",
    client_industry_id: initialData?.client_industry_id?.toString() || "",
    country_id: initialData?.country_id?.toString() || "",
    city_name: initialData?.city_name || "",
    city_id: initialData?.city_id?.toString() || "",
    location: initialData?.location || "",
    client_pocs: initialData?.client_pocs || [],
    is_active: isEdit ? initialData.is_active : true,
  };

  const getOptionsForField = useCallback(
    (source) => {
      switch (source) {
        case "industries":
          return industries.map((industry) => ({
            value: industry.client_industry_id.toString(),
            label: industry.industry_name,
          }));
        case "countries":
          return countries.map((country) => ({
            value: country.country_id.toString(),
            label: country.country_name,
          }));
        case "cities":
          return countryCities.map((city) => ({
            value: city.city_name.toString(),
            label: city.city_name,
          }));

        default:
          return [];
      }
    },
    [industries, countries, countryCities]
  );
  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields.client.basic.fields}
      title={isEdit ? "Update Client Information" : "Client"}
      icon={BusinessIcon}
      getOptionsForField={getOptionsForField}
      isEdit={isEdit}
      modelWidth={"40vw"}
      onDependencyChange={onDependencyChange}
    />
  );
};

export default AddClient;
